// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-button {
  --background: var(--color-white-accent);
  color: var(--color-black);
  --border-color: transparent;
}
@media (min-width: 991px) {
  .sign-up-button {
    min-height: 64px;
    font-size: 20px;
  }
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 0.5px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
  padding-inline: 3%;
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}

.forgot-password {
  cursor: pointer;
  text-align: center;
  height: 40px;
  border-radius: 26px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.forgot-password h3 {
  color: var(--color-black);
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: underline;
  font-family: AppFontMedium, sans-serif;
}
.forgot-password:hover {
  background: #f2dbd9 !important;
}

.wrapper {
  padding: 15px 25px 5px;
}
@media (max-width: 992px) {
  .wrapper {
    padding: 50px 7px 20px;
  }
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
  left: 3%;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

.main-button {
  margin-top: 40px;
}
@media (min-width: 991px) {
  .main-button {
    margin-top: 0px;
    min-height: 64px;
    font-size: 20px;
    margin-bottom: 26px;
  }
}
.main-button:hover {
  --background: var(--primary-btn) !important;
}

ion-button {
  margin: 6px 0px;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 40px;
    font-size: 16px;
  }
}
.button-wrapper ion-button p {
  font-family: AppFontMedium, sans-serif;
  color: white;
  width: 75%;
}
@media (min-width: 991px) {
  .button-wrapper ion-button p {
    width: -moz-fit-content;
    width: fit-content;
  }
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
@media (min-width: 991px) {
  .button-wrapper ion-button ion-icon {
    margin-right: 10px;
    zoom: 1;
  }
}
.button-wrapper ion-button.google {
  --background: #ebdfda;
}
.button-wrapper ion-button.google p {
  color: var(--color-black);
}
.button-wrapper ion-button.facebook {
  --background: #3b5997;
}
.button-wrapper ion-button.apple {
  --background: var(--color-black);
}
.button-wrapper ion-button.apple:hover {
  --background: var(--color-black) !important;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  background: #f6f1ef;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    background: #f6f1ef;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
  }
}
.wrapper-modal ion-item {
  --background: #f6f1ef;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper-modal .close-icon:hover {
  background: #f2dbd9;
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
  margin-bottom: 30px;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-family: AppFontBold, sans-serif;
    font-size: 20px;
    padding-top: 0px;
    margin-bottom: 10px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  letter-spacing: 0.08em;
  text-wrap: balance;
  font-size: 10px;
  padding: 0px 20px;
  margin-bottom: 15px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 12px;
    margin-bottom: 15px;
  }
}
.wrapper-modal .or {
  margin: 10px 0 15px;
}
.wrapper-modal .header-block {
  padding: 20px;
  border-bottom: 1px solid var(--color-black);
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 20px 40px 0px;
  }
}
.wrapper-modal .footer-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .footer-block {
    padding: 3px 40px 10px;
  }
}

@media (min-width: 991px) {
  ion-button {
    min-height: 40px !important;
    font-size: 16px !important;
  }
}
.input_info {
  position: absolute;
  top: 0;
}

.request-error h3 {
  color: var(--color-black);
  animation: pulseColor 4s infinite alternate;
  text-transform: uppercase;
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: var(--color-black);
  }
  60% {
    color: var(--ion-color-primary);
  }
  100% {
    color: var(--color-black);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/sign-in-modal/sign-in-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,uCAAA;EACA,yBAAA;EACA,2BAAA;AADD;ACHE;EDCF;IAME,gBAAA;IAEA,eAAA;EADA;AACF;;AAIA;EACC,6BAAA;AADD;;AAGA;EACC,gCAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AAAD;AAEC;EACC,mBAAA;AAAF;;AAUA;EACC,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAPD;AAQC;EACC,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,sCAAA;AANF;AAQC;EACC,8BAAA;AANF;;AASA;EAIC,sBAAA;AATD;AC5CE;EDiDF;IAEE,sBAAA;EAHA;AACF;;AAOA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,QAAA;AALD;;AAQA;EACC,eAAA;EACA,mBAAA;AALD;;AAQA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AALD;ACtEE;EDsEF;IAQE,4BAAA;IACA,eAAA;EAJA;AACF;;AAOA;EACC,gBAAA;AAJD;ACtFE;EDyFF;IAGE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAFA;AACF;AAGC;EACC,2CAAA;AADF;;AAIA;EACC,eAAA;AADD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAAD;AAEC;EACC,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AADF;AClHE;ED8GD;IAQE,gBAAA;IACA,eAAA;EAAD;AACF;AAIE;EACC,sCAAA;EACA,YAAA;EACA,UAAA;AAFH;AC7HE;ED4HA;IAME,uBAAA;IAAA,kBAAA;EADF;AACF;AAGE;EACC,kBAAA;EACA,SAAA;AADH;ACtIE;EDqIA;IAIE,kBAAA;IACA,OAAA;EACF;AACF;AACE;EACC,qBAAA;AACH;AAAG;EACC,yBAAA;AAEJ;AACE;EACC,qBAAA;AACH;AACE;EACC,gCAAA;AACH;AAAG;EACC,2CAAA;AAEJ;;AAGA;EAWC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAVD;AC7JE;EDwJF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;IAEA,mBAAA;IACA,8CAAA;EAMA;AACF;AACC;EACC,qBAAA;AACF;AACC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;AAAE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAEH;AAAE;EACC,mBAAA;AAEH;AAEC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAAF;AC7ME;EDqMD;IAUE,oCAAA;IACA,eAAA;IAEA,gBAAA;IACA,mBAAA;EACD;AACF;AACC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AACF;ACjOE;EDsND;IAaE,eAAA;IACA,mBAAA;EAED;AACF;AACC;EACC,mBAAA;AACF;AACC;EACC,aAAA;EACA,2CAAA;AACF;AC9OE;ED2OD;IAIE,sBAAA;EAGD;AACF;AADC;EACC,aAAA;AAGF;ACtPE;EDkPD;IAGE,sBAAA;EAKD;AACF;;AC3PE;ED2PD;IACC,2BAAA;IACA,0BAAA;EAIA;AACF;AADA;EACC,kBAAA;EACA,MAAA;AAGD;;AAEC;EACC,yBAAA;EACA,2CAAA;EACA,yBAAA;AACF;;AAEA;EACC;IACC,+BAAA;EACA;EACD;IACC,yBAAA;EACA;EACD;IACC,+BAAA;EACA;EACD;IACC,yBAAA;EACA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n.sign-up-button {\n\t--background: var(--color-white-accent);\n\tcolor: var(--color-black);\n\t--border-color: transparent;\n\n\t@include desktop {\n\t\tmin-height: 64px;\n\n\t\tfont-size: 20px;\n\t}\n}\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\nion-item {\n\t--border-width: 0.5px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\tborder: none;\n\tpadding-inline: 3%;\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n}\n\nion-item.password {\n\t@include desktop {\n\t\t// margin-bottom: 25px;\n\t}\n}\n\n.forgot-password {\n\tcursor: pointer;\n\ttext-align: center;\n\theight: 40px;\n\tborder-radius: 26px;\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\th3 {\n\t\tcolor: var(--color-black);\n\t\tfont-size: 14px;\n\t\ttext-transform: uppercase;\n\t\ttext-decoration: underline;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t}\n\t&:hover {\n\t\tbackground: #f2dbd9 !important;\n\t}\n}\n.wrapper {\n\t@include mobile {\n\t\tpadding: 50px 7px 20px;\n\t}\n\tpadding: 15px 25px 5px;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n\n\tleft: 3%;\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tletter-spacing: 0.08em;\n\n\t@include mobile {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 14px;\n\t}\n}\n\n.main-button {\n\tmargin-top: 40px;\n\t@include desktop {\n\t\tmargin-top: 0px;\n\t\tmin-height: 64px;\n\t\tfont-size: 20px;\n\t\tmargin-bottom: 26px;\n\t}\n\t&:hover {\n\t\t--background: var(--primary-btn) !important;\n\t}\n}\nion-button {\n\tmargin: 6px 0px;\n}\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\tion-button {\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\n\t\t@include desktop {\n\t\t\tmin-height: 40px;\n\t\t\tfont-size: 16px;\n\t\t\t&:not(:last-child) {\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\n\t\t\t@include desktop {\n\t\t\t\twidth: fit-content;\n\t\t\t}\n\t\t}\n\t\tion-icon {\n\t\t\tmargin-right: 10px;\n\t\t\tzoom: 0.9;\n\t\t\t@include desktop {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\tzoom: 1;\n\t\t\t}\n\t\t}\n\t\t&.google {\n\t\t\t--background: #ebdfda;\n\t\t\tp {\n\t\t\t\tcolor: var(--color-black);\n\t\t\t}\n\t\t}\n\t\t&.facebook {\n\t\t\t--background: #3b5997;\n\t\t}\n\t\t&.apple {\n\t\t\t--background: var(--color-black);\n\t\t\t&:hover {\n\t\t\t\t--background: var(--color-black) !important;\n\t\t\t}\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t\t// border: 2px solid var(--color-black);\n\t\tbackground: #f6f1ef;\n\t\tbox-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;\n\t}\n\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\tbackground: #f6f1ef;\n\tion-item {\n\t\t--background: #f6f1ef;\n\t}\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 15px;\n\t\tletter-spacing: 0.08em;\n\t\tmargin-bottom: 30px;\n\t\t@include desktop {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 20px;\n\n\t\t\tpadding-top: 0px;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t}\n\t.subtitle-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tletter-spacing: 0.08em;\n\t\ttext-wrap: balance;\n\t\tfont-size: 10px;\n\t\tpadding: 0px 20px;\n\t\tmargin-bottom: 15px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 12px;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t}\n\n\t.or {\n\t\tmargin: 10px 0 15px;\n\t}\n\t.header-block {\n\t\tpadding: 20px;\n\t\tborder-bottom: 1px solid var(--color-black);\n\t\t@include desktop {\n\t\t\tpadding: 20px 40px 0px;\n\t\t}\n\t}\n\t.footer-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\tpadding: 3px 40px 10px;\n\t\t}\n\t}\n}\n\n@include desktop {\n\tion-button {\n\t\tmin-height: 40px !important;\n\t\tfont-size: 16px !important;\n\t}\n}\n\n.input_info {\n\tposition: absolute;\n\ttop: 0;\n}\n\n\n.request-error {\n\th3 {\n\t\tcolor: var(--color-black);\n\t\tanimation: pulseColor 4s infinite alternate;\n\t\ttext-transform: uppercase;\n\t}\n}\n@keyframes pulseColor {\n\t0% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t30% {\n\t\tcolor: var(--color-black);\n\t}\n\t60% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t100% {\n\t\tcolor: var(--color-black);\n\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
